export const environment = {
    production: false,
    apiEndpoint: 'https://staging-userservice.vlinkgroup.net/api'
};
